// 简体中文
export default {
  nav: {
    brandSub: 'AWS 高级合作伙伴',
    links: {
      products: '云服务',
      solutions: '解决方案',
      why: '为什么选择我们',
      about: '关于我们',
      news: '新闻动态'
    },
    cta: '免费咨询 →',
    ctaMobile: '免费咨询',
    menu: '菜单',
    language: '语言'
  },

  hero: {
    badge: 'AWS 高级合作伙伴 · 已服务 2,000+ 企业',
    titlePre1: '让云',
    titleHi1: '驱动创新',
    titlePre2: '让业务',
    titleHi2: '全球通达',
    lead: 'Easycloud 作为 AWS 高级合作伙伴，为企业提供高质量、低成本的一站式 AWS 云解决方案。从云迁移、架构优化到托管运维，助力企业拥抱数字转型，开拓全球市场。',
    ctaPrimary: '免费咨询方案',
    ctaGhost: '探索服务 ↓',
    stats: [
      { value: '2,000+', label: '服务企业客户' },
      { value: '5+', label: '全球服务据点' },
      { value: '20+', label: 'AWS 认证专家' }
    ],
    panelTitle: 'AWS Console',
    panelLive: '运行中',
    utilLabel: '全局资源利用率',
    mini: [
      { k: '运行实例', v: '3,200+', d: '+12%' },
      { k: '月均节省', v: '38%', d: '成本优化' },
      { k: '迁移成功率', v: '99.8%', d: '零中断' },
      { k: '运维告警', v: '0', d: '稳定' }
    ],
    floatA: { title: 'AWS WAF 架构', sub: 'Well-Architected' },
    floatB: { title: '全球节点', sub: '33 个区域' },
    trust: ['互联网', '游戏', '金融科技', '电商零售', 'SaaS', '物联网 IoT', '社交媒体', '教育科技']
  },

  products: {
    eyebrow: 'Our Services',
    titlePre: '五大核心服务，',
    titleHi: '赋能企业云上之旅',
    lead: '作为 AWS 高级合作伙伴，Easycloud 提供从云迁移、架构优化到托管运维的全生命周期服务，助力企业降本增效、加速创新。',
    detailLink: '了解详情 →',
    items: [
      {
        title: '云迁移服务',
        desc: '从评估发现到迁移落地，提供完整的迁移方法论与实施框架，确保业务零中断平滑上云。',
        features: ['工作负载评估与规划', '自动化迁移与容器化', '迁移方案验证与压测']
      },
      {
        title: 'Well-Architected 架构审查',
        desc: '基于 AWS Well-Architected Framework，全面评估现有架构，发现风险并优化设计。',
        features: ['六大支柱全面审查', '1:1 架构师指导', '免费架构评估报告']
      },
      {
        title: 'DevOps 服务',
        desc: '基于 AWS 的 CI/CD 与可观测性方案，自动化部署流程，缩短发布周期，提升运维效率。',
        features: ['CI/CD 流水线建设', 'Prometheus/Grafana 监控', 'DevOps 文化与培训']
      },
      {
        title: '托管运维服务 (MSP)',
        desc: '7×24 小时全托管云运维，专属客户服务团队，让您专注于业务创新，运维交给我们。',
        features: ['24/7 监控与告警', '专属客户工作组', '成本优化与账单分析']
      },
      {
        title: '数据与分析服务',
        desc: '基于 AWS 数据湖与分析服务，整合多源数据，实现商业智能与数据驱动决策。',
        features: ['数据湖构建与整合', 'BI 可视化报表', '机器学习与 AI 赋能']
      },
      {
        title: '账户管理服务',
        desc: 'AWS 账户全生命周期管理，包含费用优化、产品更新、技术支持与培训。',
        features: ['用量报告与账单分析', '预算告警与成本管控', '新产品功能推送']
      }
    ]
  },

  solutions: {
    eyebrow: 'Industry Solutions',
    titlePre: '深耕行业场景的',
    titleHi: 'AWS 云解决方案',
    lead: '沉淀多年行业实践，基于 AWS 全球领先的基础设施，提供端到端的场景化方案，帮助企业降本增效、加速全球化布局。',
    cta: '获取行业方案',
    items: [
      {
        name: '互联网',
        title: '互联网云 · 加速内容分发与全球扩展',
        desc: '为短视频、内容平台等互联网企业提供 AWS 架构优化方案，显著降低内容加载时间与跨域传输成本。',
        points: ['CloudFront CDN 全球加速', 'Auto Scaling 应对流量洪峰', 'S3 + CloudFront 低成本存储分发'],
        metrics: [{ value: '70%', label: '加载时间降低' }, { value: '40%', label: '传输成本节省' }]
      },
      {
        name: '游戏',
        title: '游戏云 · 高性能计算与全球部署',
        desc: '基于 AWS 高性能计算资源，为游戏开发企业提供全球服务器部署、负载均衡与低延迟体验。',
        points: ['EC2 高性能实例与 GameLift', '跨区域多活部署', '低延迟全球玩家接入'],
        metrics: [{ value: '80%', label: '峰值故障降低' }, { value: '<50ms', label: '全球延迟' }]
      },
      {
        name: '金融科技',
        title: '金融云 · 数据驱动的精准决策',
        desc: '借助 AWS 数据分析服务，为金融科技企业提供用户画像、实时分析与可视化报表能力。',
        points: ['Redshift/BigQuery 数据分析', '用户精准画像与行为预测', '实时可视化报表与决策支持'],
        metrics: [{ value: '3x', label: '分析效率提升' }, { value: '99.99%', label: '服务可用性' }]
      },
      {
        name: '物联网 IoT',
        title: 'IoT 云 · 安全可靠的万物互联',
        desc: '基于 AWS IoT 服务，支持百万级设备连接，确保数据安全与设备可靠性。',
        points: ['AWS IoT Core 海量设备接入', '实时数据采集与分析', '高级安全协议保护'],
        metrics: [{ value: '百万级', label: '设备连接' }, { value: '99.9%', label: '数据可靠性' }]
      },
      {
        name: '电商零售',
        title: '零售云 · 弹性应对每一次流量洪峰',
        desc: '为电商企业提供弹性架构与智能运营方案，平稳度过大促流量高峰，提升转化率。',
        points: ['Auto Scaling 弹性应对大促', '个性化推荐与精准营销', '全渠道会员与交易打通'],
        metrics: [{ value: '3x', label: '大促承载能力' }, { value: '28%', label: '转化率提升' }]
      }
    ]
  },

  why: {
    eyebrow: 'Why Easycloud',
    titlePre: '企业为什么选择',
    titleHi: ' Easycloud',
    lead: '作为 AWS 高级合作伙伴，我们以技术为根基、以服务为承诺，为每一位客户提供经过验证的专业技术咨询与云解决方案。',
    features: [
      { icon: '🏅', title: '官方认证合作伙伴', desc: 'AWS 高级咨询合作伙伴，具备经过验证的技术实力与丰富的服务经验。' },
      { icon: '💡', title: '专家指导，而非猜测', desc: '提供经过验证的专业技术咨询，让您的云决策准确、安全、与长期目标一致。' },
      { icon: '🔁', title: '端到端价值创造', desc: '从咨询、架构设计到部署、培训与托管运维，全程负责，确保转型产生实际商业价值。' },
      { icon: '💰', title: '节省时间、预算与精力', desc: '避免错误技术选型带来的损失，精简执行流程，让您专注于业务扩展。' },
      { icon: '🌏', title: '区域领先，全球标准', desc: '深耕亚太区域，同时具备全球视野，为有全球业务需求的企业提供可靠的云服务。' },
      { icon: '🤝', title: '本地化支持', desc: '提供本地语言 L1/L2 支持，更快的故障响应，支持银行转账与合规发票。' }
    ],
    stats: [
      { value: '2,000+', label: '服务企业客户' },
      { value: '5+', label: '年行业经验' },
      { value: '5+', label: '全球服务据点' },
      { value: '20+', label: 'AWS 认证专家' }
    ]
  },

  about: {
    eyebrow: 'About Easycloud',
    titleLine1: '赋能企业云创新，',
    titleHi: '让数字化转型更简单',
    text1: 'Easycloud 成立于 2021 年，作为 AWS 高级合作伙伴，我们从香港、上海、东京、新加坡、迪拜五大战略据点出发，为全球企业提供高质量的 IT 服务现代化解决方案。',
    text2: '我们坚信云技术应当简化业务而非增加复杂性。作为 AWS 托管服务提供商 (MSP)，我们在云迁移、架构设计、DevOps、数据分析与托管服务方面设计与运营智能、低成本的云环境，服务于金融、零售、IoT、游戏、互联网与社交等行业。',
    pillars: [
      { icon: '🎯', title: '使命', desc: '推进云解决方案，帮助企业更高效运营、更快创新' },
      { icon: '🌏', title: '愿景', desc: '成为企业最信赖的全球 AWS 云合作伙伴' },
      { icon: '💎', title: '价值观', desc: '技术卓越 · 紧密协作 · 结果导向' }
    ],
    certsLabel: '合作伙伴认证',
    certs: ['AWS 高级咨询合作伙伴', 'AWS MSP 合作伙伴', 'Well-Architected 合作伙伴', 'AWS 认证解决方案架构师'],
    orbitSub: 'AWS Partner'
  },

  partners: {
    label: '已获得众多行业领先企业的信赖',
    quote: 'Easycloud 帮助我们在三个月内完成核心系统上云迁移，借助 AWS Well-Architected Review 优化架构，资源成本降低近 40%，系统稳定性和弹性能力都得到了质的飞跃。他们不仅是云服务商，更是值得信赖的技术伙伴。',
    authorName: '林敏',
    authorRole: '某互联网科技公司 · CTO',
    authorAvatar: '林'
  },

  news: {
    eyebrow: 'News & Insights',
    titlePre: '新闻动态与',
    titleHi: '行业洞察',
    more: '查看全部 →',
    readMore: '阅读全文 →',
    featured: {
      tag: '活动',
      title: 'AWS re:Invent 2025 圆满落幕：生成式 AI 与智能体成焦点',
      desc: 'AWS 年度旗舰大会再度于拉斯维加斯举行，主题演讲涵盖 Amazon Bedrock、Amazon Q 与智能体 AI，并发布了面向大规模构建的计算、存储与数据库新能力。'
    },
    items: [
      { tag: '生成式 AI', title: 'Amazon Nova：Amazon Bedrock 上的新一代基础模型' },
      { tag: '数据库', title: 'Amazon Aurora DSQL：无服务器分布式 SQL，多活高可用' },
      { tag: '开发者工具', title: 'Amazon Q Developer：贯穿软件开发全流程的生成式 AI 助手' },
      { tag: '计算', title: 'AWS Graviton4：为 Amazon EC2 带来更强性能与性价比' }
    ]
  },

  contact: {
    eyebrow: 'Get Started',
    titlePre: '准备好开启',
    titleHi: ' AWS 云上之旅',
    titleSuf: '了吗？',
    lead: '留下您的需求，Easycloud AWS 架构专家将在 1 个工作日内与您联系，为您提供专属上云方案与报价。',
    info: {
      email: 'hello@easycloud.com',
      address: '香港 · 上海 · 东京 · 新加坡 · 迪拜'
    },
    form: {
      name: '您的称呼',
      namePlaceholder: '请输入姓名',
      contact: '联系方式',
      contactPlaceholder: '手机号 / 邮箱',
      company: '企业名称',
      companyPlaceholder: '选填',
      message: '需求描述',
      messagePlaceholder: '简单描述您的业务场景或需求'
    },
    submit: '提交咨询',
    submitted: '✓ 已提交，感谢您！',
    hint: '提交即代表您同意 Easycloud 的隐私政策与服务条款'
  },

  footer: {
    desc: 'AWS 高级合作伙伴，提供云迁移、架构优化、DevOps 与托管运维的一站式服务。',
    brandSub: 'AWS Partner',
    columns: [
      {
        title: '服务',
        links: [
          { label: '云迁移服务', href: '#products' },
          { label: 'Well-Architected 审查', href: '#products' },
          { label: 'DevOps 服务', href: '#products' },
          { label: '托管运维 (MSP)', href: '#products' }
        ]
      },
      {
        title: '解决方案',
        links: [
          { label: '互联网', href: '#solutions' },
          { label: '游戏', href: '#solutions' },
          { label: '金融科技', href: '#solutions' },
          { label: '物联网 IoT', href: '#solutions' }
        ]
      },
      {
        title: '关于',
        links: [
          { label: '公司介绍', href: '#about' },
          { label: '新闻动态', href: '#news' },
          { label: '加入我们', href: '#contact' },
          { label: '联系我们', href: '#contact' }
        ]
      },
      {
        title: '支持',
        links: [
          { label: '帮助文档', href: '#contact' },
          { label: '服务状态', href: '#contact' },
          { label: '工单系统', href: '#contact' }
        ]
      }
    ],
    copyright: '© 2026 Easycloud. AWS 高级合作伙伴. 保留所有权利.',
    legal: ['隐私政策', '服务条款']
  },

  common: {
    backToTop: '返回顶部'
  }
}
